import { FC } from 'react';
import { FLAG_SOFT_AMEND_ENABLED } from 'config/env';
import { EditButtonWithIcon } from './primitives';
import { DetailsBooking } from 'types';
import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';

const EditButton: FC<{ booking: DetailsBooking; openModal: Function }> = ({ booking, openModal, ...rest }) => {
  if (!FLAG_SOFT_AMEND_ENABLED) return null;

  const {
    flags: { isBooked, isChangeInProgress, isFinalising },
  } = booking;

  if (!isBooked || isChangeInProgress || isFinalising) return null;

  const handleClick = () => {
    tracking.editDetailsPopUp('Link Selected');
    openModal();
  };

  return <EditButtonWithIcon {...rest} onClick={handleClick} />;
};

export default EditButton;
